/* eslint-disable prettier/prettier */
import { useState, useEffect, useMemo } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";
import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";
import themeDark from "assets/theme-dark";
import themeDarkRTL from "assets/theme-dark/theme-rtl";
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import routes from "routes";
import { useMaterialUIController, setMiniSidenav, setOpenConfigurator } from "context";
import brandWhite from "assets/images/logo-ct.png";
import brandDark from "assets/images/logo-ct-dark.png";

export default function App() {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, layout, openConfigurator, sidenavColor, transparentSidenav, whiteSidenav, darkMode } = controller;
  const direction = "rtl";
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();

  // Get the user role from LocalStorage
  const userRole = localStorage.getItem("userRole");

  // Filter routes dynamically based on the allowedRoles array in routes.js
  const filteredRoutes = routes.filter((route) => {
    // Always allow the sign-in route
    if (route.key === "sign-in") return true;
    
    // If the route has rules, check if the user's role is in the array
    if (route.allowedRoles) {
      return route.allowedRoles.includes(userRole);
    }

    // If no rules are set, hide it to be safe
    return false;
  });

  useMemo(() => {
    const cacheRtl = createCache({ key: "rtl", stylisPlugins: [rtlPlugin] });
    setRtlCache(cacheRtl);
  }, []);

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) return getRoutes(route.collapse);
      if (route.route) return <Route exact path={route.route} element={route.component} key={route.key} />;
      return null;
    });

  const configsButton = (
    <MDBox display="flex" justifyContent="center" alignItems="center" width="3.25rem" height="3.25rem" bgColor="white" shadow="sm" borderRadius="50%" position="fixed" right="2rem" bottom="2rem" zIndex={99} color="dark" sx={{ cursor: "pointer" }} onClick={handleConfiguratorOpen}>
      <Icon fontSize="small" color="inherit">settings</Icon>
    </MDBox>
  );

  return (
    <CacheProvider value={rtlCache}>
      <ThemeProvider theme={darkMode ? themeDarkRTL : themeRTL}>
        <CssBaseline />
        {layout === "dashboard" && pathname !== "/sign-in" &&  (
          <>
            <Sidenav
              color={sidenavColor}
              brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
              brandName="مستر وفايي"
              routes={filteredRoutes} // 🟢 UPDATED to use filtered routes
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
            <Configurator />
            {configsButton}
          </>
        )}
        {layout === "vr" && <Configurator />}
        <Routes>
          {getRoutes(filteredRoutes)} {/* 🟢 UPDATED to use filtered routes */}
          
          {/* 🟢 UPDATED: Redirect to login if not logged in, otherwise go to orders */}
 <Route path="*" element={<Navigate to={userRole ? "/dashboard" : "/sign-in"} />} />       </Routes>
      </ThemeProvider>
    </CacheProvider>
  );
}